
import {
  FormControl,
  Box,
  FormHelperText,
  Slider,
  Typography,
} from '@mui/material';
import type { SliderProps } from '@mui/material';

interface TemperatureFieldProps {
  value: number;
  setValue: (value: number) => void;
}

export default function TemperatureField({ value, setValue, ...rest }: TemperatureFieldProps) {
  const handleChange: NonNullable<SliderProps['onChange']> = (_event, newValue) => {
    setValue(parseFloat(String(newValue)));
  };

  return (
    <Box>
      <FormControl fullWidth required>
        <Typography>Temperature</Typography>
        <Slider
          {...rest}
          aria-label='Temperature'
          value={value}
          valueLabelDisplay='auto'
          aria-describedby='temperature-helper-text'
          onChange={handleChange}
          step={0.01}
          min={0}
          max={2}
        />

        <FormHelperText id='temperature-helper-text'>
          The value used to modulate the next token probabilities.
        </FormHelperText>
      </FormControl>
    </Box>
  );
}
